import { Chip } from '@mui/material';
import moment from 'moment';

/**
 * Column definitions for the SkillX assignments grid.
 * Fields map to the skillx_assignments row returned by the studentPortal
 * controller. `id` is the DataGrid row id (see rowUniqueId in the view).
 */
export const SkillxAssignments_Table_Head = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'title', headerName: 'Title', width: 240 },
  {
    field: 'module_label',
    headerName: 'Module',
    width: 160,
    renderCell: (params) => params.row.module_label || '—',
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 320,
    renderCell: (params) => params.row.description || '—',
  },
  {
    field: 'course_available_id',
    headerName: 'Course ID',
    width: 110,
    renderCell: (params) => params.row.course_available_id ?? '—',
  },
  {
    field: 'due_date',
    headerName: 'Due Date',
    width: 140,
    renderCell: (params) =>
      params.row.due_date ? moment(params.row.due_date).format('DD MMM YYYY') : '—',
  },
  { field: 'max_grade', headerName: 'Max Grade', width: 110 },
  {
    field: 'is_published',
    headerName: 'Status',
    width: 130,
    renderCell: (params) => (
      <Chip
        size="small"
        label={params.row.is_published ? 'Published' : 'Draft'}
        sx={{
          backgroundColor: params.row.is_published ? '#c8facd' : '#eff4f9',
          color: params.row.is_published ? '#0db05d' : '#3173b4',
          fontWeight: 600,
        }}
      />
    ),
  },
  {
    field: 'created_at',
    headerName: 'Created',
    width: 140,
    renderCell: (params) =>
      params.row.created_at ? moment(params.row.created_at).format('DD MMM YYYY') : '—',
  },
];
